<div class="w100" fxLayout="column" fxLayoutAlign="start stretch">
  <ng-container *ngIf="!menuVisible">
    <!-- <button mat-fab color="primary" class="botMenuProd" (click)="abreMenu.emit(true)">
    <mat-icon>list</mat-icon>
  </button> -->
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row">
      <button mat-mini-fab color="primary" class="mr-10" (click)="abreMenu.emit(true)">
        <mat-icon>list</mat-icon>
      </button>
      <p *ngIf="!productoActual"><em>{{'CONTENIDO.BOTONES.VERPROD_1' | translate}}</em></p>
      <p *ngIf="productoActual"><em>{{'CONTENIDO.BOTONES.VERPROD_2' | translate}}</em></p>
    </div>
    <div fxLayout="row" *ngIf="!detallesVisible">
      <p><em>{{'DETALLES.TITULO' | translate}}</em></p>
      <button mat-mini-fab color="primary" class="ml-10" (click)="abreDetalles.emit(true)">
        <mat-icon>info</mat-icon>
      </button>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!productoActual; else infoProducto">
  <div fxLayout="column" fxLayoutAlign="start center">
    <h1>{{'CONTENIDO.PREVIA.TITULO' | translate}}</h1>
    <h3>{{'CONTENIDO.PREVIA.SUBTITULO' | translate}}</h3>
  </div>
</ng-container>
<ng-template #infoProducto>
  <ng-container *ngIf="!encuestaCreada">
    <div class="mat-elevation-z4 pr-20 pl-20 m-20" fxLayout="row" fxLayoutAlign="center center">
      <h2>{{'CONTENIDO.ESTADOS.NOCREADA' | translate}}</h2>
      <mat-icon class="ml-20 s-40">error_outline</mat-icon>
    </div>
  </ng-container>
  <ng-container *ngIf="encuestaCreada">
    <ng-container *ngIf="cargandoStatusEncuesta">
      <div fxLayout="column" fxLayoutAlign="start center" class="p-20">
        <p>{{'CONTENIDO.PREVIA.CARGANDO' | translate}}</p>
        <mat-spinner class="m-20" *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
      </div>
    </ng-container>
    <ng-container *ngIf="!cargandoStatusEncuesta">
      <ng-container *ngIf="!encuestaActiva; else encuestaOk">
        <div class="mat-elevation-z4 pr-20 pl-20 m-20" fxLayout="row" fxLayoutAlign="center center">
          <h2>{{'CONTENIDO.ESTADOS.NOINICIADA' | translate}}</h2>
          <mat-icon class="ml-20 s-40">error_outline</mat-icon>
        </div>
      </ng-container>
      <ng-template #encuestaOk>
        <ng-container *ngIf="!ocultarContenidoGoFlow">
          <mat-card class="example-card mat-elevation-z4 m-20" *ngIf="detallesVisible">
            <mat-card-header>
              <mat-card-subtitle fxFlex>{{'DETALLES.TITULO' | translate}}</mat-card-subtitle>
              <div fxLayout="row" fxLayoutAlign="end center" fxFlex>
                <button mat-stroked-button (click)="detallesVisible = !detallesVisible">{{'CONTENIDO.BOTONES.OCULTAR' | translate}}</button>
              </div>
            </mat-card-header>
            <mat-card-content>
              <mat-list>
                <mat-list-item class="pt-0">
                  <div class="" fxLayout="row" fxLayoutAlign="start start" fxFlex="100">
                    <div  fxLayout="column" fxLayoutAlign="start stretch" fxFlex="65">
                      <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxLayout="row" fxLayoutAlign="start center" [fxFlex]="50">
                          <mat-icon mat-list-icon>star</mat-icon>
                          <p mat-line><b>{{'DETALLES.PRODUCTO' | translate}}</b><em>{{'CONSULTATABLA.PRODUCTOS.' + datosDetallesProducto.producto | translate}} {{datosDetallesProducto.anio}}</em></p>
                        </div>
                        <!-- <ng-container *ngIf="tokenConfig">
                          <div fxLayout="row" fxLayoutAlign="start center" [fxFlex]="50">
                            <mat-icon mat-list-icon>vpn_key</mat-icon>
                            <p mat-line>
                              <b class="tamLetra">{{'DETALLES.SURVEYTOKEN' | translate}}: </b>
                              <em class="tamLetra">{{tokenConfig}}</em>
                            </p>
                          </div>
                        </ng-container> -->
                      </div>
                      <div fxLayout="row" fxLayoutAlign="space-between start">
                        <div class="" fxLayout="column" fxFlex="50">
                          <ng-container *ngFor="let fecha of datosDetallesProducto.fechasProducto">
                            <div fxLayout="row" fxLayoutAlign="start center" [fxFlex]="50" *ngIf="fecha.activa">
                              <mat-icon mat-list-icon>event</mat-icon>
                              <p mat-line>
                                <b>{{'DETALLES.FECHAS.' + fecha.tipo | translate}}: </b>
                                <em *ngIf="productoActual.idProducto!=3">{{fecha.fecha | date:"d MMM y H:mm" : offsetPipe : idiomaActual}} ( {{cityname | translate}} {{fecha.fecha |date:'O' : offsetPipe : idiomaActual}})</em>
                                <em *ngIf="productoActual.idProducto==3">{{fecha.fecha | date:"d MMM y H:mm" :"+00:00":idiomaActual}}</em>
                                <!-- <em >{{fecha.fecha | date:"d MMM y H:mm"}}</em> -->
                              </p>
                            </div>
                          </ng-container>

                        </div>
                        <div fxLayout="column" fxLayoutAlign="start start" fxFlex="50">
                          <div *ngIf="mostrarMatRecorda">
                            <mat-accordion class="example-headers-align " multi>
                              <mat-expansion-panel class="mat-elevation-z0 contentMat">
                                <mat-expansion-panel-header>
                                  <mat-panel-title>
                                    <div fxLayout="row" fxLayoutAlign="start start">
                                      <span class="material-icons-outlined">event_note</span>
                                      <b>{{'DETALLES.FECHAS.recordatorio'| translate}}: </b>
                                    </div>
                                  </mat-panel-title>
                                  <mat-panel-description>
                                  </mat-panel-description>
                                </mat-expansion-panel-header>
                                <mat-list role="list"  class="mt">
                                  <mat-list-item role="listitem" *ngFor="let fecha of recordatoriosFullInfo">
                                    <div fxLayout="row" fxLayoutAlign="start start">
                                      <span class="material-icons-outlined">arrow_right</span>
                                      <em>{{fecha.fechaRecordatorio | date:"d MMM y H:mm" : offsetPipe : idiomaActual}} ( {{cityname | translate}} {{fecha.fechaRecordatorio |date:'O' : offsetPipe : idiomaActual}})</em>
                                    </div>
                                    <mat-divider></mat-divider>
                                  </mat-list-item>
                                </mat-list>
                              </mat-expansion-panel>
                            </mat-accordion>
                          </div>
                          <div *ngIf="mostrarMatAvisos">
                            <mat-accordion class="example-headers-align" multi>
                              <mat-expansion-panel class="mat-elevation-z0 contentMat">
                                <mat-expansion-panel-header>
                                  <mat-panel-title>
                                    <div fxLayout="row" fxLayoutAlign="start start">
                                      <span class="material-icons-outlined">event_note</span>
                                      <b>{{'DETALLES.FECHAS.avisos'| translate}}: </b>
                                    </div>
                                  </mat-panel-title>
                                  <mat-panel-description>
                                  </mat-panel-description>
                                </mat-expansion-panel-header>
                                <mat-list role="list"  class="mt">
                                  <mat-list-item role="listitem" *ngFor="let fecha of fechasAvisos">
                                    <div fxLayout="row" fxLayoutAlign="start start">
                                      <span class="material-icons-outlined">arrow_right</span>
                                      <em *ngIf="datosDetallesProducto.producto!=63">{{fecha.aviso | date:"d MMM y H:mm" : offsetPipe : idiomaActual}} ( {{cityname | translate}} {{fecha.aviso |date:'O' : offsetPipe : idiomaActual}})</em>
                                      <em *ngIf="datosDetallesProducto.producto==63">{{fecha.fechaRecordatorio | date:"d MMM y H:mm" : offsetPipe : idiomaActual}} ( {{cityname | translate}} {{fecha.fechaRecordatorio |date:'O' : offsetPipe : idiomaActual}})</em>
                                    </div>
                                    <mat-divider></mat-divider>
                                  </mat-list-item>
                                </mat-list>
                              </mat-expansion-panel>
                            </mat-accordion>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div  fxLayout="column" fxLayoutAlign="start stretch" fxFlex="35">
                      <ng-container *ngIf="tokenConfig">
                        <div fxLayout="row" fxLayoutAlign="start center">
                          <mat-icon mat-list-icon>vpn_key</mat-icon>
                          <p mat-line>
                            <b class="tamLetra">{{'DETALLES.SURVEYTOKEN' | translate}}: </b>
                            <em class="tamLetra">{{tokenConfig}}</em>
                          </p>
                        </div>
                      </ng-container>


                      <ng-container *ngIf="accountId">
                        <div fxLayout="row" fxLayoutAlign="start center" >
                          <mat-icon mat-list-icon>vpn_key</mat-icon>
                          <p mat-line>
                            <b class="tamLetra">{{'DETALLES.ACCOUNT_ID' | translate}}: </b>
                            <em class="tamLetra">{{accountId}}</em>
                          </p>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="oportunity_id">
                        <div fxLayout="row" fxLayoutAlign="start center" >
                          <mat-icon mat-list-icon>vpn_key</mat-icon>
                          <p mat-line>
                            <b class="tamLetra">{{'DETALLES.OPORTUNITY_ID' | translate}}: </b>
                            <em class="tamLetra">{{oportunity_id}}</em>
                          </p>
                        </div>
                      </ng-container>


                    </div>
                  </div>
                </mat-list-item>
                <mat-divider [inset]="true"></mat-divider>
                <h3 mat-subheader>{{'DETALLES.PROGRESO' | translate}}</h3>
                <mat-list-item>
                  <ng-container [ngSwitch]="datosDetallesProducto.producto">
                    <ng-container *ngSwitchCase="3">
                      <div fxLayout="column" fxLayoutAlign="start stretch" class="w100" *ngIf="datosDetallesProducto.producto == 3 || datosDetallesProducto.producto == 63">
                        <div fxLayout="row" fxLayoutAlign="space-between">
                          <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="48">
                            <div fxLayout="column" fxLayoutAlign="start center">
                              <h3 class="m-0">{{'DETALLES.AVANCES.MAS50_2' | translate}}: <b>{{datosDetallesProducto.progresoNom35.mas50.porcentaje | number :'1.0-2'}}%</b></h3>
                            </div>
                            <mat-progress-bar mode="buffer" [value]="datosDetallesProducto.progresoNom35.mas50.porcentaje" class="barraAvance"></mat-progress-bar>
                          </div>
                          <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="48">
                            <div fxLayout="column" fxLayoutAlign="start center">
                              <h3 class="m-0">{{'DETALLES.AVANCES.MENOS50_2' | translate}}: <b>{{datosDetallesProducto.progresoNom35.menos50.porcentaje | number :'1.0-2'}}%</b></h3>
                            </div>
                            <mat-progress-bar mode="buffer" [value]="datosDetallesProducto.progresoNom35.menos50.porcentaje" class="barraAvance"></mat-progress-bar>
                          </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="center">
                          <p><b>{{'DETALLES.DIASREST' | translate}}{{datosDetallesProducto.diasRestantes}}</b></p>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="63">
                      <div fxLayout="column" fxLayoutAlign="start stretch" class="w100" *ngIf="datosDetallesProducto.producto == 3 || datosDetallesProducto.producto == 63">
                        <div fxLayout="row" fxLayoutAlign="space-between">
                          <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="48">
                            <div fxLayout="column" fxLayoutAlign="start center">
                              <h3 class="m-0">{{'DETALLES.AVANCES.MAS50_2' | translate}}: <b>{{datosDetallesProducto.progresoNom35.mas50.porcentaje | number :'1.0-2'}}%</b></h3>
                            </div>
                            <mat-progress-bar mode="buffer" [value]="datosDetallesProducto.progresoNom35.mas50.porcentaje" class="barraAvance"></mat-progress-bar>
                          </div>
                          <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="48">
                            <div fxLayout="column" fxLayoutAlign="start center">
                              <h3 class="m-0">{{'DETALLES.AVANCES.MENOS50_2' | translate}}: <b>{{datosDetallesProducto.progresoNom35.menos50.porcentaje | number :'1.0-2'}}%</b></h3>
                            </div>
                            <mat-progress-bar mode="buffer" [value]="datosDetallesProducto.progresoNom35.menos50.porcentaje" class="barraAvance"></mat-progress-bar>
                          </div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="center">
                          <p><b>{{'DETALLES.DIASREST' | translate}}{{datosDetallesProducto.diasRestantes}}</b></p>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <div fxLayout="row wrap" class="w100">
                        <div fxLayout="column" fxLayoutAlign="start center" fxFlex="100">
                          <h3 class="m-0">{{'DETALLES.AVANCES.NORMAL' | translate}}<b>{{datosDetallesProducto.progreso.porcentaje | number :'1.0-2'}}%</b></h3>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                          <mat-progress-bar mode="buffer" [value]="datosDetallesProducto.progreso.porcentaje" class="barraAvance" fxFlex></mat-progress-bar>
                          <p class="ml-20"><b>{{'DETALLES.DIASREST' | translate}}{{datosDetallesProducto.diasRestantes}}</b></p>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>


                </mat-list-item>
              </mat-list>
            </mat-card-content>
          </mat-card>

        </ng-container>

        <mat-tab-group (selectedTabChange)="indiceTab($event)">
          <mat-tab *ngIf="!ocultarContenidoGoFlow">
            <ng-template mat-tab-label>
              <mat-icon class="example-tab-icon mr-10">people</mat-icon>
              {{'COLABORADORES.TAB' | translate}}
            </ng-template>
            <colaboradores [setStatusBoton]="setStatusBoton.asObservable()" [infoEmpresaProducto]="infoEmpresaProducto.asObservable()"></colaboradores>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="example-tab-icon mr-10">assignment_turned_in</mat-icon>
              {{'ACCIONES.TAB' | translate}}
            </ng-template>
            <acciones [setStatusBoton]="setStatusBoton.asObservable()" [infoSurveyCheck]="infoSurveyCheck.asObservable()" [infoEmpresaProducto]="infoEmpresaProducto.asObservable()" (actualizarStatusEncuesta)="obtieneToken()" (actualizarProrroga)="getProrrogasFechasCierre($event)" (verResultadosIframe)="verResultadosIframe($event)" (actualizarRecordatorios)="actualizarRecordatorios($event)" (actualizarAvisos)="actualizarAvisos($event)" (actualizarFechIniCie)="actualizarFechIniCie($event)"></acciones>
          </mat-tab>
          <!-- <mat-tab >
            <ng-template mat-tab-label>
              <mat-icon class="example-tab-icon mr-10">history</mat-icon>
              {{'HISTORIAL_MAILS.TAB' | translate}}
            </ng-template>
            <log-emails [infoEmpresaProducto]="infoEmpresaProducto.asObservable()"></log-emails>
          </mat-tab> -->
          <mat-tab *ngIf="!ocultarContenidoGoFlow">
            <ng-template mat-tab-label>
              <mat-icon class="example-tab-icon mr-10">calendar_view_day</mat-icon>
              {{'EMAI_LOG.TAB' | translate}}
            </ng-template>
            <vizualizador-emails [infoEmpresaProducto]="infoEmpresaProducto.asObservable()" [consultarEmailLog]="consultarEmailLog.asObservable()"></vizualizador-emails>
          </mat-tab>

          <mat-tab *ngIf="!tipoProductoNorma && !ocultarContenidoGoFlow">
            <ng-template mat-tab-label>
              <mat-icon class="example-tab-icon mr-10">verified_user</mat-icon>
              {{'AUDITORIA.TAB_TIT_AUDI' | translate}}
            </ng-template>
            <auditoria [infoEmpresaProducto]="infoEmpresaProducto.asObservable()"></auditoria>
          </mat-tab>
        </mat-tab-group>
      </ng-template>
    </ng-container>
  </ng-container>
</ng-template>
</div>
